import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { C31IconCTABorderedCardProps } from './C31IconCTABorderedCard';
import { C31IconCTABorderedProps } from './C31IconCTABordered';
import { IconCtaBorderedCardProps, IconCtaBorderedProps } from '@ahc-digital/component-library';
import { ICON_CTA_BORDERED_CARDS } from 'src/shared/static';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';

export function CreateIconCTABorderedCardModel(props?: C31IconCTABorderedCardProps) {
  type t = IconCtaBorderedCardProps;
  const { params, fields } = props || {};
  const { renderRichText, renderLink, renderText } = useConditionalRendering();
  const firstCTAStyle = getDroplink<t['firstCTAStyle']>(params?.FirstCTAStyle, 'button');
  const secondCTAStyle = getDroplink<t['secondCTAStyle']>(params?.SecondCTAStyle, 'button');
  const topColorBar = getDroplink<t['topColorBar']>(params?.TopBorderColor, 'none');
  const headlineTag = getDroplink<t['headlineTag']>(params?.TitleType, 'p');
  return {
    icon: props?.fields?.Icon?.fields?.Value?.value as t['icon'],
    firstCTAStyle,
    secondCTAStyle,
    headlineTag,
    topColorBar,
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    firstCTA: renderLink(fields?.FirstCTA),
    secondCTA: renderLink(fields?.SecondCTA),
  };
}

export function CreateIconCTABorderedModel(props?: C31IconCTABorderedProps) {
  type t = IconCtaBorderedProps;
  const { params, fields } = props || {};
  const { renderRichText, renderText } = useConditionalRendering();

  const headlineTag = getDroplink<t['headlineTag']>(params?.TitleType, 'p');
  const numberOfColumns = getDroplink<t['numberOfColumns']>(params?.NumberOfColumns, '2');

  return {
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    bottomSupportCopy: renderRichText(fields?.BottomSupportCopy),
    headlineTag,
    numberOfColumns,
    children: props?.rendering && (
      <Placeholder name={ICON_CTA_BORDERED_CARDS} rendering={props.rendering} />
    ),
  };
}
